/* @flow */

import React from 'react';
import {useSelector} from 'react-redux';

import Box from '@material-ui/core/Box';

import CompanyItemComponent from 'components/company';

import CompanyLookupBaseComponent from '../base';

import Company from 'models/companies/company';

type CompanyLookupReset2FAComponentProps = {
  company: Company;
  companyErrorLabelId: string;
  required: boolean;
  handleSelect: (company: Company) => void;
}

export default function CompanyLookupReset2FAComponent(props: CompanyLookupReset2FAComponentProps) {
  const countries = useSelector(state => state.locale.countries);

  if (props.company) {
    return (
      <Box px={4} py={3} bgcolor="lightblue.main">
        <CompanyItemComponent
          buttonLabelId="component.offer.tab1.company.change"
          company={props.company}
          selected
          selectHandler={() => props.handleSelect(null)}
        />
      </Box>
    );
  }

  return (
    <CompanyLookupBaseComponent
      company={props.company}
      companyErrorLabelId={props.companyErrorLabelId}
      countries={countries}
      required={props.required}
      onlyExisting
      handleSelect={props.handleSelect}
    />
  );
}
